module.exports = __webpack_public_path__ + "static/media/box_pc.ff82c36c.svg";